import { render, staticRenderFns } from "./DocumentosPersonal.vue?vue&type=template&id=af11202a&scoped=true"
import script from "./DocumentosPersonal.vue?vue&type=script&lang=js"
export * from "./DocumentosPersonal.vue?vue&type=script&lang=js"
import style0 from "./DocumentosPersonal.vue?vue&type=style&index=0&id=af11202a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af11202a",
  null
  
)

export default component.exports